import React from 'react';

function FilterFieldset({ label, name, onReset, resetLabel, children }) {
  return (
    <fieldset className="filter-fieldset">
      <legend htmlFor={name} className="text text--bold text--meta">
        {label}

        {onReset && (
          <button type="button" onClick={onReset} aria-label={resetLabel}>
            {resetLabel}
          </button>
        )}
      </legend>

      {children}
    </fieldset>
  );
}

export default FilterFieldset;
